/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/GetFileNameWithoutExtension.ts
 * @create:      2025-07-01 17:59:44.225
 * @modify:      2025-07-11 21:19:12.928
 * @version:     6.0.0
 * @times:       4
 * @lines:       61
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { TrimEnd } from "../string/TrimEnd";
import { GetFileExtension } from "./GetFileExtension";
import { GetFileName } from "./GetFileName";

/**
 * Returns the file name without its extension from a given file path or file name.
 *
 * @param fileName - The full file path or file name to process.
 * @returns The file name without its extension.
 *
 * @remarks
 * This function uses `GetFileName` to extract the file name from the path,
 * then removes the extension (as determined by `GetFileExtension`) and any trailing dot.
 *
 * @example
 * ```typescript
 * GetFileNameWithoutExtension("folder/example.txt"); // Returns "example"
 * GetFileNameWithoutExtension("archive.tar.gz"); // Returns "archive.tar"
 * ```
 * 
 * @since 1.1.7
 * @version 2021-12-07
 */
export function GetFileNameWithoutExtension(fileName: string) {
    const name = GetFileName(fileName);
    const ext = GetFileExtension(fileName);
    return TrimEnd(name, [ext, "."], false);
}
